
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0zm0 2C15.431 2 2 15.431 2 32c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30C62 15.431 48.569 2 32 2z"}}),_c('path',{attrs:{"d":"M22.4 44.8h6.4V19.2h-6.4zM35.2 44.8h6.4V19.2h-6.4z"}})])])
          )
        }
      }
    